import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Grid, GridColumn as Column, GridCell, GridToolbar } from '@progress/kendo-react-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
import ClassroomCommandCell from './Classroom-Command-Cell';
import ClassroomComboBox from '../ClassroomComboBox';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{ childId: string; }>;

var PropsCopy: {
    childId: string;
};

type State = {
    sort: SortDescriptor[];
    origClassrooms: ClassroomData[];
    Classrooms: ClassroomData[];
    isLoading: boolean;
    childId: number;
}

export interface ClassroomData {
    ClassroomId: number;
    FacilityName: string;
    FacilityID: number;
    RoomName: string;
    RoomId: string;
    inEdit: boolean;
    AttendeeId: number;
    [key: string]: any;
}

export interface ClassroomSearchResult {
    ClassroomId: number;
    RoomName: string;
    RoomId: string;
    FacilityName: string;
    FacilityId: number;
}

class RoomNameCell extends GridCell {
    myCallback = (dataFromAutoComplete: ClassroomSearchResult) => {
        this.props.dataItem.ClassroomId = dataFromAutoComplete.ClassroomId;
        this.props.dataItem.RoomName = dataFromAutoComplete.RoomName;
        this.props.dataItem.RoomId = dataFromAutoComplete.RoomId;
        this.props.dataItem.FacilityID = dataFromAutoComplete.FacilityId;
        this.props.dataItem.FacilityName = dataFromAutoComplete.FacilityName;
    };

    render() {
        if (this.props.dataItem.RoomName == null) {
            return (
                <td>
                    <ClassroomComboBox
                        style={{ color: '#007bff', width: '100%' }}
                        childId={parseInt(PropsCopy.childId)}
                        callbackFromParent={this.myCallback.bind(this)} />
                </td>
            );
        } else {
            return (
                <td>
                    <Link style={{ color: '#007bff' }} to={`/classroom/${this.props.dataItem.ClassroomId}`}>
                        {this.props.dataItem.RoomName}
                    </Link>
                </td>
            );
        }
    }
}

class RoomIdCell extends GridCell {
    render() {
        if (this.props.dataItem.RoomName == null) {
            return (
                <td>-</td>
            );
        } else {
            return (
                <td>{this.props.dataItem.RoomId}</td>
            );
        }
    }
}

class FacilityNameCell extends GridCell {
    render() {
        if (this.props.dataItem.RoomName == null) {
            return (
                <td>-</td>
            );
        } else {
            return (
                <td>
                    <Link style={{ color: '#007bff' }} to={`/facility/${this.props.dataItem.FacilityID}`}>
                        {this.props.dataItem.FacilityName}
                    </Link>
                </td>
            );
        }
    }
}

export default class ChildClassrooms extends React.Component<Props, State> {
    CommandCell: any;

    constructor(props: Props) {
        super(props);
        this.state = {
            Classrooms: [],
            origClassrooms: [],
            isLoading: false,
            childId: 0,
            sort: [],
        };
        this.sortChange = this.sortChange.bind(this);

        this.enterInsert = this.enterInsert.bind(this);
        this.itemChange = this.itemChange.bind(this);

        const save = this.save.bind(this);
        const cancel = this.cancel.bind(this);
        const remove = this.remove.bind(this);
        this.CommandCell = ClassroomCommandCell(null, remove, save, cancel, "inEdit");
    }

    public componentWillMount() {

        this.getClassrooms();
    }

    public render() {
        return <React.Fragment>
            {this.state.isLoading && <LoadingPanel />}
            <DocumentTitle title="Classrooms" />
            <br />
            <div className="row">
                <div className="col">
                    <h1>Classrooms</h1>
                </div>
            </div>
            <Grid data={this.state.Classrooms}
                sortable={{
                    allowUnsort: true
                }}
                sort={this.state.sort}
                onSortChange={this.sortChange}
            >
                <GridToolbar>
                    <button
                        title="Assign classroom"
                        className="k-button k-primary"
                        onClick={this.enterInsert}
                    >Assign classroom
                    </button>
                    {this.state.Classrooms.filter(p => p.inEdit).length > 0 && (
                        <button
                            title="Cancel current changes"
                            className="k-button"
                            onClick={(e) => this.setState({ Classrooms: this.state.origClassrooms.slice() })}
                        >Cancel current changes
                            </button>
                    )}
                </GridToolbar >
                <Column field="RoomName" title="Name" cell={RoomNameCell} />
                <Column field="RoomId" title="Room Id" cell={RoomIdCell} />
                <Column field="FacilityName" title="Facility" cell={FacilityNameCell} />
                <Column cell={this.CommandCell} width="190px" />
            </Grid>
            <br />
        </React.Fragment>;
    }

    private sortChange(event: any) {
        this.setState({
            sort: event.sort,
            Classrooms: orderBy(this.state.Classrooms, event.sort)
        });
    }

    private getClassrooms() {
        PropsCopy = this.props.match.params;
        let _childId = parseInt(this.props.match.params.childId) || 0;
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID"),
            ChildID: _childId
        }
        this.setState({ isLoading: true, childId: _childId });
        fetchApi('api/ChildClassrooms/AssignedClassrooms', data, 'POST')
            .then((data: ClassroomData[]) => {
                this.setState({ Classrooms: data, isLoading: false, origClassrooms: data });
            });
    }

    enterInsert() {
        const dataItem = { inEdit: true };
        const newproducts = this.state.Classrooms.slice();
        newproducts.unshift(dataItem as ClassroomData);
        this.update(newproducts, dataItem as ClassroomData, false);
        this.setState({
            Classrooms: newproducts
        });
    }

    itemChange(event: any) {
        const value = event.value;
        let name = event.field;
        if (!name) {
            return;
        }
        const updatedData = this.state.Classrooms.slice();
        let item = this.update(updatedData, event.dataItem, false);
        item[name] = value;
        this.setState({
            Classrooms: updatedData
        });
    }

    save(dataItem: ClassroomData) {
        dataItem.inEdit = false;
        fetchApi(`api/ChildClassrooms/AssignClassroom/${this.state.childId}`, dataItem, 'POST').then((response: any) => {
            dataItem.AttendeeId = response.AttendeeId as number;
            dataItem.ClassroomId = this.update(this.state.origClassrooms, dataItem as ClassroomData, false).ClassroomId;
            this.setState({
                Classrooms: this.state.Classrooms.slice()
            });
        });
    }

    cancel(dataItem: ClassroomData) {
        if (dataItem.ClassroomId && this.state.origClassrooms.length) {
            let originalItem = this.state.origClassrooms.find(p => p.ClassroomId === dataItem.ClassroomId);
            if (originalItem == null)
                this.update(this.state.Classrooms, dataItem, true);
            else
                this.update(this.state.Classrooms, originalItem as ClassroomData, false);
        } else {
            this.update(this.state.Classrooms, dataItem, true);
        }
        this.setState({
            Classrooms: this.state.Classrooms.slice()
        });
    }

    remove(dataItem: ClassroomData) {
        dataItem.inEdit = false;
        this.update(this.state.Classrooms, dataItem, true);
        this.update(this.state.origClassrooms, dataItem, true);

        fetchApi(`api/ChildClassrooms/RemoveClassroomAssignment/${dataItem.AttendeeId}`, {}, 'DELETE').then(() => {
        //fetchApi(`api/Classrooms/RemoveChild/${dataItem.AttendeeId}`, {}, 'DELETE').then(() => {
            this.setState({
                Classrooms: this.state.Classrooms.slice()
            });
        });
    }


    update(data: ClassroomData[], item: ClassroomData, remove: boolean) {
        let updated;
        let index = data.findIndex(p => p === item || item.ClassroomId != null && p.ClassroomId === item.ClassroomId);
        if (index >= 0) {
            updated = Object.assign({}, item);
            data[index] = updated;
        } else {
            updated = Object.assign({}, item);
            data.unshift(updated);
            index = 0;
        }

        if (remove) {
            data = data.splice(index, 1);
        }

        return data[index];
    }
}
